export function QuickbooksSettingsCtrl (
  $q,
  $rootScope,
  $state,
  $scope,
  $translate,
  $window,
  accountingSettings,
  confirm,
  messages,
  quickbooksApi,
  session,
  settings,
  workshopAPI
  ) {

    $scope.accountingSettings = accountingSettings;
    $scope.loaded             = true;
    $scope.session            = session;
    $scope.settings           = settings;
    $scope.showWarning        = true;

    $scope.authorize = function () {
      $q.when()
      .then(() => $rootScope.Company.confirmAccountingIntegration())
      .then(() => {
        return $rootScope.Company.isLinkedToBranch() && !$rootScope.Company.isSharedAccounting() ?
          $rootScope.Company.shareAccounting('qbo') :
          $q.when('false');
      })
      .then(() => quickbooksApi.checkExistingIntegrations())
      .then(response => {
        return response === 'true' ?
          confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.CONFIRM_INTEGRATION', {
            name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
          }))
          .catch(() => {
            return confirm.textConfirm($translate.instant('JS_SPACE.INTEGRATIONS.CLEAR_ID_STATEMENT'), $translate.instant('JS_SPACE.INTEGRATIONS.CLEAR_IDS'))
            .then(() => quickbooksApi.clearID());
          }) :
          $q.when(true);
      })
      .then(() => quickbooksApi.authorize())
      .then(() => workshopAPI.get('/quickbooks_online/authenticate'))
      .then(url => {
        $window.location.assign(url.url);
      })
      .catch(err => {
        messages.error(err);
      });
    };

    $scope.unauthorize = function () {
      confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISE', {
        name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
      }))
      .then(() => workshopAPI.get('/company/remove_qbo'))
      .then(() => {
        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.UNAUTHORISED', {
          name: $translate.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE')
        }), 'success');

        $state.reload();
      }).catch(err => {
        messages.error(err);
      });
    };

    $scope.getOptions = function () {
      $scope.loading = true;

      $q.all({
        accounts: quickbooksApi.getAccounts(),
        rates   : workshopAPI.get('/quickbooks_online/tax_rates'),
      })
      .then(data => {
        $scope.allAccounts     = data.accounts.all_accounts;
        $scope.bankAccounts    = data.accounts.bank_accounts;
        $scope.expenseAccounts = data.accounts.expense_accounts;
        $scope.incomeAccounts  = data.accounts.income_accounts;
        $scope.taxRates        = data.rates.all_tax_rates;
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.loading = false;
      });
    };

    $scope.hideWarning = function () {
      $scope.showWarning = false;
    };

    $scope.setPurchasesTaxGroup = function () {
      $scope.settings.qbo_purchases_tax_group_id = $scope.taxRates.filter(tax => tax.id === $scope.settings.qbo_purchases_tax_id)[0].purchases_tax_group;
    };

    $scope.setSalesTaxGroup = function () {
      $scope.settings.qbo_sales_tax_group_id = $scope.taxRates.filter(tax => tax.id === $scope.settings.qbo_sales_tax_id)[0].sales_tax_group;
    };

    $scope.setZeroTaxSalesGroup = function () {
      $scope.settings.qbo_zero_tax_group_id = $scope.taxRates.filter(tax => tax.id === $scope.settings.qbo_zero_tax_id)[0].sales_tax_group;
    };

    $scope.setZeroTaxPurchasesGroup = function () {
      $scope.settings.qbo_zero_tax_group_id_purchases = $scope.taxRates.filter(tax => tax.id === $scope.settings.qbo_zero_tax_id_purchases)[0].purchases_tax_group;
    };

    $scope.save = function () {
      $rootScope.Company.saveAccountingSettings($scope.accountingSettings)
        .then(() => workshopAPI.patch('/company', $scope.settings, 'company'))
        .then(() => {
          messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

          $state.reload();
        })
        .catch(err => messages.error(err));
    };

    $scope.saveAccountingSettings = function () {
      $rootScope.Company.saveAccountingSettings($scope.accountingSettings)
      .then(() => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

        $state.reload();
      })
      .catch(err => {
        messages.error(err);
      })
      .finally(() => {
        $scope.saving = false;
      });
    };

    $scope.setQBSharesAccount = function () {
      quickbooksApi.shareAccount(settings.shares_accounting)
      .then(response => {
        if (response) {
          messages.show('Shares Accounting setting successfully changed', 'success');

          $state.reload();
        }
      }).catch(err => {
        //reverts the toggle value to its original value before the call since it was returned as an error
        settings.shares_accounting = !settings.shares_accounting;
        messages.error(err);
      });
    };

    if ($rootScope.Company.hasIntegration('quickbooks') && $scope.needs_quickbooks_setup) {
      $scope.needsSetup = true;
    }
    else if ($rootScope.Company.hasIntegration('quickbooks') ) {
      $scope.getOptions();
    }

  }